import { z } from 'zod';

export const PopularServicesGroupSweetShopModelSchema = z.object({
    image: z.object({
        url: z.string(),
    }).optional().nullable(),
    articleCategories: z.array(
        z.object({
            uid: z.string(),
            name: z.string(),
            shortDescription: z.string().optional().nullable(),
        }),
    ).optional().nullable(),
});

export type PopularServicesGroupSweetShopModel
= z.infer<typeof PopularServicesGroupSweetShopModelSchema>;
